'use strict';

var $ = require('jquery');

module.exports = function (options) {
	var context = options.context;

	function init() {
		context.on('change', '[data-binding="option-other-answer"]', function () {
			if ($(this).val().length > 0) {
				context.find('[data-binding="option-hidden-other"]').prop('checked', true);
			} else {
				context.find('[data-binding="option-hidden-other"]').prop('checked', false);
			}
		});
	}

	return {
		init: init
	};
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/report-email-multiple.js
// module id = 493
// module chunks = 0